import React, { useState, useEffect, useRef, useContext } from 'react'
import { Popover, Button, makeStyles, FormGroup, RadioGroup, Radio, FormControlLabel, FormControl, CircularProgress, useMediaQuery, Checkbox, ListItemIcon, ListItemText } from "@material-ui/core";
//import { useNotify } from "react-admin";
import config from '../config.json';
import { stringify } from 'query-string';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { customTheme } from "../customTheme";
// import AppsIcon from '@material-ui/icons/Apps';
import { ContextProvider } from '../globalContextProvider';
import FilterIcon from "../images/filterIcon.svg";
import { saveTokens } from '../utils/saveTokens';

import notify from './CustomUseNotify';
import UseAnalyticsEvent from '../utils/useAnalyticsEvent';


const ListItemScroll = (props) => {

    let { resultList, indexChange, radioValue, radioHandleChange, searchText, loading, noRecords, fetchParkings, listInnerRef, displayColumnsDefaultValue, setDisplayColumnsDefaultValue, setResultList } = props
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const onScroll = () => {
        if (searchText.length === 0) {
            if (listInnerRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
                if (scrollTop > 0 && scrollTop + clientHeight === scrollHeight && !resultList[indexChange].reachedEnd) {
                    setResultList(resultList => {
                        const copy = [...resultList]
                        let paramsInc = copy[indexChange].paramsInc + 1
                        copy[indexChange] = { ...copy[indexChange], paramsInc: paramsInc }
                        fetchParkings(paramsInc)
                        return copy
                    })
                }
            }
        }
    };

    let filteredList = searchText !== "" ? resultList[indexChange].dataList.filter(val => resultList[indexChange]?.valueKey ? val[resultList[indexChange].valueKey].toLowerCase().includes(searchText.toLowerCase()) : val.general_name ? val.general_name.toLowerCase().includes(searchText.toLowerCase()) : val.name.toLowerCase().includes(searchText.toLowerCase())) : resultList[indexChange].dataList;
    const toggleColumnVisibility = column => {
        setDisplayColumnsDefaultValue(dc => {
            const temp = { ...dc };
            temp[column] = !temp[column];
            return temp;
        });
    };

    return (
        <div style={{ height: isSmallDevice ? "100%" : "100%", overflow: "hidden", marginTop: isSmallDevice ? "25px" : "0px" }}>
            <div onScroll={onScroll} ref={listInnerRef} style={{ overflow: "auto", overflowX: "hidden", height: "90%" }}>
                {resultList[indexChange].dataList[0] && resultList[indexChange].filterType !== "Display Columns" && <>
                    {
                        searchText.length >= 1 && resultList[indexChange].listType === "Dynamic" ? <FormControl component="fieldset" variant="standard">
                            {

                                resultList[indexChange].searchList.map((list) => {
                                    const keyValue = resultList[indexChange]?.valueKey ? list[resultList[indexChange].valueKey] : list.general_name ? list.general_name : list.name
                                    if(resultList[indexChange].filterFormat === "Checkbox") {
                                        const checkedValues = radioValue[indexChange].value
                                        return (
                                            <FormGroup aria-label="gender"
                                            name="controlled-radio-buttons-group"
                                            value={radioValue[indexChange].value}
                                            onChange={(e) => radioHandleChange(e, list)}
                                            style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                        >
                                            <FormControlLabel checked={checkedValues.includes(keyValue)} value={keyValue} size="small" control={<Checkbox size='small' />} label={keyValue}/>
                                        </FormGroup>
                                        )
                                    }
                                    return (
                                        <RadioGroup aria-label="gender"
                                            name="controlled-radio-buttons-group"
                                            value={radioValue[indexChange].value}
                                            onChange={(e) => radioHandleChange(e, list)}
                                            style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                        >
                                            <FormControlLabel size="small" value={keyValue} control={<Radio />} label={keyValue} />
                                        </RadioGroup>
                                    )
                                })
                            }
                        </FormControl> : <FormControl component="fieldset" variant="standard">
                            {filteredList.map((list) => {
                                 const keyValue = resultList[indexChange]?.valueKey ? list[resultList[indexChange].valueKey] : list.general_name ? list.general_name : list.name
                                if(resultList[indexChange].filterFormat === "Checkbox"){
                                    const checkedValues = radioValue[indexChange].value
                                    return (<FormGroup aria-label="gender"
                                    name="controlled-radio-buttons-group"
                                    value={radioValue[indexChange].value}
                                    onChange={(e) => radioHandleChange(e, list)}
                                    style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                >
                                    <FormControlLabel checked={checkedValues.includes(keyValue)} value={keyValue} size="small" control={<Checkbox size='small' />} label={keyValue}/>
                                </FormGroup>)
                                }
                                return (
                                    <RadioGroup aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={radioValue[indexChange].value}
                                        onChange={(e) => radioHandleChange(e, list)}
                                        style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                    >
                                        <FormControlLabel value={keyValue} control={<Radio />} label={keyValue} />
                                    </RadioGroup>

                                )
                            })}
                            {filteredList.length === 0 && resultList[indexChange].caseType === "Static" && <p className='noRecords'>No results found for <span style={{ fontWeight: "bold" }}>{searchText}</span></p>}
                            {filteredList.length === 0 && resultList[indexChange].caseType === "Zones" && <p className='noRecords'>Please select <span style={{ fontWeight: "bold" }}>Parking Name.</span></p>}
                            {filteredList.length === 0 && resultList[indexChange].listType === "Dynamic" && <p className='noRecords'>No records found.</p>}
                        </FormControl>
                    }
                </>}


                {resultList[indexChange].filterType === "Display Columns" && <>
                    {Object.keys(displayColumnsDefaultValue)
                        .map(column => (
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }} key={column} onClick={() => toggleColumnVisibility(column)} >
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={displayColumnsDefaultValue[column]}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText primary={column} />
                            </div>
                        ))}
                </>}
                {!loading && noRecords && !resultList[indexChange].dataList[0] && <p className='noRecords'>No results found</p>}
                {loading && !resultList[indexChange].dataList[0] && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 5, marginBottom: 5 }}><CircularProgress size={20} /></div>}
                {loading && resultList[indexChange].dataList[0] && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 5, marginBottom: 25 }}><CircularProgress size={20} /></div>}
            </div>
        </div >
    )
}


export default function CustomFilter(props) {
    const { handleAccessKey, filterTypesInitState, filterListValue, setFilterListValue, accessKeyId, setCurrentParking, currentParkingFlag, pathName, defaultColumns, storageKey, displayColumns, setDisplayColumns, buttonProps = {} } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const useStyles = makeStyles({
        root: {
            height: isSmallDevice ? "40px" : "auto",
            width: isSmallDevice ? "200px" : "100px"
        },
        muiPopoverPaper: {
            minWidth: "380px",
            width: !isSmallDevice ? "40%" : "none",
            position: isSmallDevice ? "static" : "absolute",
            border: "1px #E0E5EC solid",
            height: isSmallDevice ? "100vh" : "440px",
            maxWidth: "none",
            maxHeight: "none",
            fontFamily: "Poppins-Medium",
            backgroundColor: "#F5F8FA"
        },
        imageIcon: {
            display: 'flex',
            height: 'inherit',
            width: 'inherit'
        },
        mySvgStyle: {
            color: "#334d6e"
        }
    });
    const { setIsChange } = useContext(ContextProvider);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [searchText, setSearchText] = useState("");
    const listInnerRef = useRef(null);

    const eventTracker = UseAnalyticsEvent();

    const [resultList, setResultList] = useState([]);
    const [indexChange, setIndexChange] = useState(0);
    const [radioValue, setRadioValue] = useState([])

    const fetchParkingTimeout = useRef(null);
    const [loading, setLoading] = useState(false)
    const [noRecords, setNoRecords] = useState(false)
    const [reset, setRest] = useState(false)
    const [displayColumnsDefaultValue, setDisplayColumnsDefaultValue] = useState(defaultColumns)
    const [textInput, setTextInput] = useState("");
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleClick = (event) => {
        setDefaultValuesHandler()
        setAnchorEl(event.currentTarget);
        setIsChange(false)
        if (filterListValue) {
            setRadioValue([...filterListValue])
        }
        setDisplayColumnsDefaultValue(displayColumns)
        setSearchText("")
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const fetchParkings = (paramsInc) => {
        const token = sessionStorage.getItem('token');
        const perPage = 15
        if (resultList[indexChange].listType === "Dynamic") {
            if (token != null && token !== "") {
                setLoading(true)
                var params = {
                    user_id: sessionStorage.getItem("user_id"),
                    filter: JSON.stringify({ [resultList[indexChange].resourceParam ? resultList[indexChange].resourceParam : resultList[indexChange].source]: searchText, ...resultList[indexChange].filterParams }),
                    sort: JSON.stringify(["name", "ASC"]),
                    page: searchText.length >= 1 ? 1 : paramsInc,
                    perPage
                }
                fetch(`${config.HOST_NAME}/crm/v3/${resultList[indexChange].resourcePath}?${stringify(params)}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    },
                })
                    .then(response => {
                        saveTokens(response)
                        return response.json()
                    })
                    .then((responseJson) => {
                        if (responseJson.success) {
                            if (responseJson.data.length === 0) setNoRecords(true);
                                const copy = [...resultList]
                                if (responseJson.data && responseJson.data.length < perPage) {
                                    copy[indexChange] = { ...copy[indexChange], reachedEnd: true }
                                }
                                if (responseJson.data && responseJson.data[0] && responseJson.data[0].access_key_id && typeof handleAccessKey === "function") {
                                    handleAccessKey(responseJson.data[0].access_key_id);
                                }
                                if (reset) {
                                    setRest(false)
                                    copy[indexChange].dataList = responseJson.data
                                }
                                else if (searchText.length >= 1 && resultList[indexChange].listType === "Dynamic") {
                                    copy[indexChange].searchList = responseJson.data
                                }
                                else if (searchText.length === 0 && responseJson.data) {
                                    if (copy[indexChange].searchList.length !== 0) {
                                        copy[indexChange].dataList = [...responseJson.data]
                                    }
                                    copy[indexChange].dataList = [...copy[indexChange].dataList, ...responseJson.data]
                                }
                                setResultList(copy)
                        } else notify(responseJson.message, 'warning');
                    })
                    .catch((e) => {
                        notify('Error fetching data', 'warning');
                        console.log(e);
                    }).finally (() =>{
                        setLoading(false)
                    })
            }
        }
    };

    const onChangeHandler = (index) => {
        setIndexChange(index)
        setSearchText("")
        setNoRecords(false)
        scrollToTop()
    }

    const radioHandleChange = (e, list) => {
        if (resultList[indexChange].filterFormat === "Checkbox") {
            setRadioValue(radioValue => {
                let copy = [...radioValue]
                let copyItem = { ...copy[indexChange] };
                if (copyItem.value.includes(e.target.value)) {
                    copyItem.value = copyItem.value.filter((val) => val !== e.target.value)
                    if(copyItem.id) copyItem.id = copyItem.id.filter((val) => val !== list.id)
                    copy[indexChange] = copyItem
                    return copy
                }
                copyItem.value = [...copyItem.value, e.target.value]
                copyItem.id = [...copyItem.id, list.id]
                copy[indexChange] = copyItem
                return copy
            });

        } else {
            setRadioValue(radioValue => {
                let copy = [...radioValue]
                let copyItem = { ...copy[indexChange] };
                copyItem.value = e.target.value
                copyItem.id = list.id
                copy[indexChange] = copyItem
                // console.log(copy);
                return copy
            });
        }

        if (resultList[indexChange].filterType === "Parking Name") {
            let currentParking = list
            //Only for Zones
            const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
            const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
            const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
                { id, name: zoneLabels[index] }
            )) : null;
            if (finalZones)
                finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

            setResultList(resultList => {
                const copy = [...resultList]
                copy[indexChange + 1].dataList = [...copy[indexChange + 1].dataList, ...finalZones]
                return copy
            })
        }
    };


    const searchHandleChange = (event) => {
        setSearchText(event.target.value)
    };

    const onTextChange = (event) => {
        let value = event.target.value
        const isValidInput = /^[0-9]*$/.test(value);
        if (isValidInput) setTextInput(value);
        else setTextInput(value ? value.slice(0, -1) : "")
        setRadioValue(radioValue => {
            let copy = [...radioValue]
            let copyItem = { ...copy[indexChange] };
            copyItem.value = value === "" || value === "0" ? undefined : isValidInput ? value * 60 : value ? value.slice(0, -1) * 60 : ""
            copy[indexChange] = copyItem
            return copy
        });
    }

    const onChangeRangeFilter = ({ min, max }) => {
        setRadioValue(radioValue => {
            let copy = [...radioValue]
            let copyItem = { ...copy[indexChange] };
            copyItem.value = `${min}-${max}`
            copy[indexChange] = copyItem
            return copy
        });
    }

    const filterRequest = () => {
        // setFilterList(radioValue)
        if (sessionStorage.getItem(pathName)) {
            let prevdata = JSON.parse(sessionStorage.getItem(pathName))
            sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, radioValue: radioValue }))
        } else {
            sessionStorage.setItem(`${pathName}`, JSON.stringify({ radioValue: radioValue }))
        }
        setFilterListValue(radioValue)
        setIsChange(true)
        if (currentParkingFlag) {
            setCurrentParking(null)
        }

        if (defaultColumns) {
            setDisplayColumns(displayColumnsDefaultValue)
            localStorage.setItem(storageKey, JSON.stringify(displayColumnsDefaultValue));
        }

        handleClose()
    };

    const scrollToTop = () => {
        if (listInnerRef.current) listInnerRef.current.scrollTop = 0
    }

    const clearHandler = () => {
        setRadioValue(radioValue => {
            let copy = [...radioValue]
            let copyItem = { ...copy[indexChange] };
            copyItem.value = ""
            copyItem.id = ""
            copy[indexChange] = copyItem
            if (copyItem.filterType === 'Duration') setTextInput("")
            return copy
        });
    }

    const resetHandler = () => {
        setFilterListValue(null)
        setRest(true)
        setRadioValue(resultList.map((val) => { return { filterType: val.filterType, value: "", id: "" } }))
        setTextInput("")
        setIndexChange(0)
        scrollToTop()
    }

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        if (anchorEl && resultList[0]) fetchParkingTimeout.current = setTimeout(fetchParkings, 800)
        // Track the analytics event when the filter is applied
        eventTracker('Filter', 'Applied');
    }, [searchText, accessKeyId]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (anchorEl && resultList[0] && resultList[indexChange].dataList.length === 0) {
            fetchParkings(resultList[indexChange].paramsInc)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [indexChange, anchorEl])

    const setDefaultValuesHandler = () => {
        let stateAfterFilter = filterTypesInitState.filter((val) => val.showFilter)
            .map((val) => {
                if (val.listType === 'Static') {
                    if (val.filterType === 'Vehicle') {
                        if (sessionStorage.getItem("vehicle_types") !== "null" && sessionStorage.getItem("vehicle_types") != null) {
                            return { ...val, dataList: val.dataList.filter(item => JSON.parse(sessionStorage.getItem("vehicle_types")).includes(item.id)), paramsInc: 1, reachedEnd: false }
                        }
                        else return { ...val, paramsInc: 1, reachedEnd: false }
                    } else return { ...val, dataList: val.dataList.filter(item => item.show !== false), paramsInc: 1, reachedEnd: false }
                }
                return { ...val, paramsInc: 1, reachedEnd: false }
            })

        let filterListValueOfResultList = stateAfterFilter.map((val) => {
            return { filterType: val.filterType, value: "", id: "" }
        })

        setResultList(stateAfterFilter)
        setRadioValue([...filterListValueOfResultList])
    }

    return (
        <div style={{ display: "flex", justifyContent: "start", alignItems: "start", columnGap: 30 }}>
            <Button className='buttonStyle addBorderRadius fontWeightMedium' variant="contained" aria-describedby={id} disableElevation size="small" onClick={handleClick} {...buttonProps}>
                <img src={FilterIcon} alt="Filter Icon" width={16} height={16} style={{ marginRight: 10 }} />
                <div>Filter</div>
                {
                    filterListValue && filterListValue.filter((selectedFilter) => selectedFilter.id !== "" || selectedFilter.value !== "").length > 0 &&
                    <div style={{ display: "fex", justifyContent: "center", alignItems: 'center', borderRadius: 20, color: "#fff", backgroundColor: "#F7685B", height: 16, width: 16, marginLeft: 5 }}>
                        <div style={{ fontSize: 10 }}>{filterListValue ? filterListValue.filter((selectedFilter) => (selectedFilter.id !== "" || selectedFilter.value !== "" || (Array.isArray(selectedFilter.value) && selectedFilter.value.length > 0))).length : 0}</div>
                    </div>
                }
            </Button>
            {/* {
                isSmallDevice && <IconButton className="customStyleBtn customStyleBtnSmallScreen" onClick={handleClick} aria-label="delete" style={{ marginRight: "10px" }}  {...iconButtonProps}>
                    <Badge badgeContent={filterListValue ? filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length : 0} invisible={filterListValue && filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length > 0 ? false : true}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        color="secondary">
                        <img src={FilterIcon} alt="Filter Icon" width={22} height={22} />
                    </Badge>
                </IconButton>
            } */}
            {resultList[0] && radioValue[0] &&
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    elevation={2}
                    classes={{
                        paper: classes.muiPopoverPaper
                    }}

                >
                    <div style={{ width: "auto", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px #E0E5EC solid", padding: isSmallDevice ? "10px 20px" : "0px 20px", backgroundColor: "#F5F8FA" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 10 }}>
                            <FilterListIcon style={{ fill: "#18cc69" }} />
                            <p>Filter by</p>
                        </div>
                        <CloseIcon style={{ cursor: "pointer", fill: "#18cc69" }} onClick={() => handleClose()} />
                    </div>
                    <div style={{ display: "flex", height: isSmallDevice ? "77%" : "74%", }}>
                        <div className='filterTypeContainer' style={{ backgroundColor: "#F5F8FA", borderRight: "1px #E0E5EC solid", fontSize: 12, width: isSmallDevice ? "60%" : "50%" }}>

                            <div style={{ maxHeight: "325px", overflowY: "auto" }} className="custom-scrollbar">
                                {resultList.map((list, index) => {
                                    let count = radioValue.map((val) => val.filterType === list.filterType && ((val.id !== "" || val.value !== "") || (Array.isArray(val.value) && val.value.length > 0)));

                                    return (
                                        <div className={index === indexChange ? "filterTypeActive" : "filterType"} style={{ padding: "1px 10px", cursor: "pointer" }} onClick={() => onChangeHandler(index)}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <p>{list.filterType}</p>
                                                {count.length !== 0 && count[index] && <p style={{ backgroundColor: "#334D6E", color: "#FFF", fontSize: 8, borderRadius: 20, textAlign: "center", width: 13 }}>1</p>}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className='filterSearchContainer' style={{ padding: "20px 20px", width: "100%", backgroundColor: "#fff" }}>
                            {resultList[indexChange].filterFormat !== 'Range' &&
                                <div className='inputFilterContainer' style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {resultList[indexChange].filterFormat !== 'Text' && <SearchIcon style={{ fill: "#18cc69" }} />}
                                    <input className='inputFilter'
                                        type="text"
                                        value={resultList[indexChange].filterFormat !== 'Text' ? searchText : textInput}
                                        onChange={resultList[indexChange].filterFormat !== 'Text' ? searchHandleChange : onTextChange}
                                        placeholder={resultList[indexChange].filterFormat !== 'Text' ? 'Search' : 'Minutes'}
                                        disabled={resultList[indexChange].filterFormat !== 'Text' && resultList[indexChange].dataList.length === 0 ? true : false}
                                    />
                                </div>
                            }

                            {resultList[indexChange].filterFormat !== 'Text' && resultList[indexChange].filterFormat !== 'Range' && <ListItemScroll resultList={resultList} indexChange={indexChange} radioValue={radioValue} radioHandleChange={radioHandleChange} fetchParkings={fetchParkings} searchText={searchText} loading={loading} noRecords={noRecords} listInnerRef={listInnerRef} displayColumnsDefaultValue={displayColumnsDefaultValue} setDisplayColumnsDefaultValue={setDisplayColumnsDefaultValue} setResultList={setResultList} />}
                            {resultList[indexChange].filterFormat === 'Range' && <RangeSlider filterListValue={filterListValue} indexChange={indexChange} radioValue={radioValue} onChangeRangeFilter={(val) => onChangeRangeFilter(val)} />}

                        </div>
                    </div>
                    <div style={{ width: "auto", display: "flex", justifyContent: "flex-end", alignItems: "center", columnGap: 20, borderTop: "1px #E0E5EC solid", padding: isSmallDevice ? "0px 20px" : "12px 20px", height: isSmallDevice ? "12%" : "auto", backgroundColor: "#F5F8FA", minHeight: isSmallDevice ? "84px" : "none" }}>
                        <Button size='small' className={classes.root} color='primary' variant="text" disableElevation onClick={clearHandler}>
                            Clear
                        </Button>
                        <Button size='small' className={classes.root} color='primary' variant="outlined" disableElevation onClick={resetHandler}>
                            Reset
                        </Button>
                        <Button size='small' className={classes.root} color='primary' variant="contained" disableElevation onClick={filterRequest}>
                            Apply
                        </Button>
                    </div>
                </Popover >
            }
        </div >
    );
}

const RangeSlider = ({ filterListValue, indexChange, radioValue, onChangeRangeFilter }) => {
    let confidenceRange = filterListValue && filterListValue[indexChange]?.value
    const min = 0
    const max = 100
    const [minVal, setMinVal] = useState(confidenceRange ? confidenceRange.split("-")[0] : min);
    const [maxVal, setMaxVal] = useState(confidenceRange ? confidenceRange.split("-")[1] : max);
    const minValRef = React.useRef(null);
    const maxValRef = React.useRef(null);
    const range = React.useRef(null);
    const thumbRef = React.useRef(null)

    const getPercent = React.useCallback(
        (value) => Math.round(((value - min) / (max - min)) * 100),
        [min, max]
    );

    useEffect(() => {
        if (maxValRef.current) {
            const minPercent = getPercent(minVal);
            const maxPercent = getPercent(+maxValRef.current.value);

            if (range.current) {
                range.current.style.left = `${minPercent}%`;
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [minVal, getPercent]);

    useEffect(() => {
        if (minValRef.current) {
            const minPercent = getPercent(+minValRef.current.value);
            const maxPercent = getPercent(maxVal);

            if (range.current) {
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [maxVal, getPercent]);

    useEffect(() => {
        if (onChangeRangeFilter && thumbRef.current) onChangeRangeFilter({ min: minVal, max: maxVal });
    }, [minVal, maxVal]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (radioValue && radioValue[indexChange].filterType === 'Confidence' && radioValue[indexChange].value === '') {
            setMinVal(0)
            setMaxVal(100)
        }
    }, [radioValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <input className={`thumb thumb--zindex-3 ${minVal > max - 100 ? 'thumb--zindex-5' : ''}`} type="range" min={min} max={max} value={minVal} ref={minValRef} step={0}
                onChange={(event) => {
                    const value = Math.min(+event.target.value, maxVal - 1);
                    setMinVal(value);
                    thumbRef.current = true
                    event.target.value = value.toString();
                }}
            />
            <input className="thumb thumb--zindex-4" type="range" min={min} max={max} value={maxVal} ref={maxValRef} step={0}
                onChange={(event) => {
                    const value = Math.max(+event.target.value, minVal + 1);
                    setMaxVal(value);
                    thumbRef.current = true
                    event.target.value = value.toString();
                }}
            />

            <div className="range_slider">
                <div className="range_slider__track" />
                <div ref={range} className="range_slider__range" />
                <div className="range_slider__left-value">{minVal}</div>
                <div className="range_slider__right-value">{maxVal}</div>
            </div>
        </div>
    );
};